import { useQuery } from '@apollo/client';

import { GET_ME } from '../queries/getMe';

/**
 * Reads the organisation's configured current/next block tags (replaces the old hardcoded
 * tag id 1774 / SKU suffix 'APR2026'). The current block drives the default class-list
 * filter and the SKU-suffix filters; the next block gates class duplication.
 */
export const useBlocks = () => {
  const { loading, data } = useQuery(GET_ME);

  const current = data?.me?.organisation?.currentBlockTag ?? null;
  const next = data?.me?.organisation?.nextBlockTag ?? null;

  const currentBlockTagId: number | null = current?.id ?? null;
  const nextBlockTagId: number | null = next?.id ?? null;

  return {
    loading,
    currentBlockTagId,
    currentBlockSuffix: (current?.code as string | undefined) ?? null,
    // The GET_CLASSES `filters` string format is `tagId:<id>` (see Course.ts getTagIds).
    currentBlockFilter: currentBlockTagId != null ? `tagId:${currentBlockTagId}` : '',
    nextBlockTagId,
    nextBlockSuffix: (next?.code as string | undefined) ?? null,
  };
};
